export const PUBLIC_ACCOUNT_FEATURES_ENABLED = false;
